import React, { useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import KeyMetricsWidget from '../KeyMetricsWidget'
import TagTable from './components/TagTable'

import withFetch from '../../../infrastructure/withFetch'
import Subtitle from '../../../components/Subtitle'
import { addToQuerystring, addQuerystring } from '../../../utils/querystring'
import { FETCH_STATUS } from '../../../infrastructure/fetch/constants'

const Page = ({
    status,
    data,
    retry,
    palette,
    queryParams: { e: eventsToCompare },
}) => {
    const location = useLocation()
    const history = useHistory()
    const [tagValues, setTagValues] = useState(null)

    const events = data.events || []
    const columnSize = events.length === 0 ? 12 : 12 / events.length

    const onSelectedTagValueIdsChanged = event => {
        setTagValues({
            ...(tagValues || {}),
            [event.eventId]: event,
        })
    }
    const updateRoute = () => {
        if (tagValues == null) return

        const newLocation = addToQuerystring(location, {
            e: eventsToCompare.map(event => {
                const customizedValues = tagValues[event.id]

                return {
                    id: event.id,
                    k:
                        customizedValues == null
                            ? event.k
                            : customizedValues.tagKeyId,
                    v:
                        customizedValues == null
                            ? event.v
                            : customizedValues.tagValueIds,
                }
            }),
        })

        history.push(newLocation)
    }

    const showRefreshButton =
        status === FETCH_STATUS.SUCCEEDED && events.some(e => e.tags.length > 0)

    const refresh = showRefreshButton && (
        <button
            className="btn btn-primary btn-xs pull-right"
            onClick={updateRoute}
        >
            Refresh
        </button>
    )

    const getInitialTagTableProps = (event, { k, v }) => {
        const tag = event.tags.find(tag => tag.id === k)

        const tagValueIdsForTagKey =
            tag == null ? [] : tag.tagValues.map(tagValue => tagValue.id)

        const selectedTagValueIds = v.length > 0 ? v : tagValueIdsForTagKey

        return {
            initialTagKeyId: k,
            initialSelectedTagValueIds: selectedTagValueIds,
            initialSelectAll:
                selectedTagValueIds.length === tagValueIdsForTagKey.length,
        }
    }

    return (
        <>
            <Subtitle title="Tags" tools={refresh}></Subtitle>
            <KeyMetricsWidget data={data} status={status} retry={retry}>
                <div className="row key-metrics m-n">
                    {events.map((event, index) => {
                        const eventDataFromQuerystring = eventsToCompare.find(
                            e => e.id === event.eventId,
                        )

                        return (
                            <div
                                className={`col-sm-${columnSize} p-xs`}
                                key={event.eventId}
                                style={{
                                    borderTop: `4px solid ${palette[index]}`,
                                }}
                            >
                                <TagTable
                                    event={event}
                                    {...getInitialTagTableProps(
                                        event,
                                        eventDataFromQuerystring,
                                    )}
                                    onSelectedTagValueIdsChanged={
                                        onSelectedTagValueIdsChanged
                                    }
                                />
                            </div>
                        )
                    })}
                </div>
            </KeyMetricsWidget>
        </>
    )
}

const Fetch = withFetch(
    ({ queryParams: { e: eventsToCompare } }) =>
        addQuerystring('/api/compare/sales/get-tags', {
            e: eventsToCompare.map(e => ({
                id: e.id,
            })),
        }),
    fetchProps => <Page {...fetchProps} />,
)

export default props => <Fetch {...props} />
